import { render, staticRenderFns } from "./InventoryKits.vue?vue&type=template&id=283f7374&scoped=true&"
import script from "./InventoryKits.vue?vue&type=script&lang=js&"
export * from "./InventoryKits.vue?vue&type=script&lang=js&"
import style0 from "./InventoryKits.vue?vue&type=style&index=0&id=283f7374&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283f7374",
  null
  
)

export default component.exports